export interface EmailShareDialogData {
  blogTitle: string;
  shareUrl: string;
}

export * from './email-share-dialog-action.service';
export * from './email-share-dialog.module';
